<template>
  <div style="position: relative;">
    <cargo-advance-select
      ref="select"
      v-bind="params.selectProps"
      :default-multiple-value="value"
      :automatic-dropdown="true"
      @parentCallBack="onParentCallBack"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import TableKeyboardNav from '@/mixin/TableKeyboardNav'

export default Vue.extend({
  name: 'CargoAgGridAdvanceMultipleSelectEditor',
  components: { cargoAdvanceSelect },
  mixins: [TableKeyboardNav],
  data() {
    return {
      value: [],
      valueType: ''
    }
  },
  mounted() {
    const { value, itemType } = this.params
    this.valueType = typeof value
    if (value && this.valueType === 'string') {
      if (itemType && itemType === 'number') {
        this.value = value.split(',').map(item => Number(item))
      } else {
        this.value = value.split(',')
      }
    } else {
      this.value = value || []
    }
    setTimeout(() => {
      this.$refs.select.$refs.advanceSelectRef.focus()
      window.addEventListener('click', this.clickOther)
    }, 100)
  },
  destroyed() {
    window.removeEventListener('click', this.clickOther)
  },
  methods: {
    // 处理布尔值
    getValue() {
      return this.value
    },
    onParentCallBack(item) {
      console.log('------', item)
      const { node, column } = this.params
      this.value = [...item.value]
      node.setDataValue(column.colId, this.value)
    },
    clickOther(e) {
      if (!this.$el.contains(e.target)) {
        const { api } = this.params
        api.stopEditing()
      }
    }
  }
})
</script>

<style>
</style>
